import React from "react"

const X = () => (
	<svg
		width="22"
		height="21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="inline-block fill-current align-middle">
		<path d="M17.3263 0.904297H20.6998L13.3297 9.32779L22 20.7903H15.2112L9.89404 13.8383L3.80995 20.7903H0.434432L8.31743 11.7804L0 0.904297H6.96111L11.7674 7.25863L17.3263 0.904297ZM16.1423 18.7711H18.0116L5.94539 2.81743H3.93946L16.1423 18.7711Z" />
	</svg>
)

export default X
